import { ImMNElement } from '../elements/elementModelTypes';
import { getTextContent } from '../elements/utils/elementPropertyUtils';
import getEditorJsonInlineCommentIds from '../tiptap/utils/jsonContentUtils/getEditorJsonInlineCommentIds';

/**
 * Gets the attached inline comments for the given element.
 */
export const getElementAttachedInlineCommentIds = (element: ImMNElement): string[] => {
    const textContent = getTextContent(element);
    return getEditorJsonInlineCommentIds(textContent);
};
